import { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";

import AdjustmentIcon from "@/assets/icons/adjustment-vertical.svg";
import Button from "@/components/Button";
import { FILTER } from "@/constants";
import Filters from "@/containers/Filters";
import useFilterParams from "@/hooks/useFilterParams";
import { SearchFilter } from "@/types/SearchFilter";
import { cx } from "@/utils";

import styles from "./FilterButton.module.css";

// List of filters that should count towards the total filter count
const COUNTABLE_FILTERS: Array<keyof SearchFilter> = [
  FILTER.CHANNEL_NAME,
  FILTER.FREETEXT,
  FILTER.CHANNEL_TYPE,
  FILTER.LANGUAGE,
  FILTER.SENTIMENT,
  FILTER.MIN_REACH,
  FILTER.MENTION_KIND,
  FILTER.INSIGHT_TYPES,
  FILTER.INSIGHT_ID,
];

// count applied filters.
const countAppliedFilters = (filters: SearchFilter) => {
  const count = 0;

  return COUNTABLE_FILTERS.reduce((total = 0, key) => {
    const f = filters?.[key];
    return total + (f ? (Array.isArray(f) ? f.length : 1) : 0);
  }, count);
};
export type FilterButtonProps = { className?: string };

const FilterButton: React.FunctionComponent<FilterButtonProps> = ({
  className,
}) => {
  const [open, setOpen] = useState(false);
  const [filters, setFilters] = useFilterParams();

  const { pathname } = useLocation();
  const appliedFilterCount = countAppliedFilters(filters);

  // Close the filter when the user routes away
  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <>
      <Button
        data-count={appliedFilterCount}
        className={cx(styles.open, className)}
        onClick={() => setOpen((v) => !v)}
        icon={AdjustmentIcon}
        data-testid="filter-button"
        variant="primary"
        iconPlacement="after"
        type="button"
      >
        {L.MENTIONS_VIEW_FILTER_BUTTON}
      </Button>

      {appliedFilterCount > 0 && (
        <Button
          className={styles.clear}
          icon={({ className }) => (
            <span className={cx(styles.count, className)}>
              {appliedFilterCount}
            </span>
          )}
          variant="secondary"
          onClick={() => setFilters({}, true)}
        >
          {L.MENTIONS_VIEW_TOOLBAR_FILTER_RESET_BUTTON_LABEL}
        </Button>
      )}

      <Filters open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default FilterButton;
